/**
 * Exibe uma notificação flutuante (toast) customizável na tela,
 * com suporte para dark mode e botão para copiar mensagens de erro.
 *
 * @param {string} message - A mensagem a ser exibida no toast.
 * @param {object} [options] - Opções de configuração para o toast.
 * @param {'info'|'success'|'error'|'warning'} [options.type='info'] - O tipo de toast.
 * @param {number} [options.duration=5000] - A duração em milissegundos.
 */
export const showToast = (message, options = {}) => {
    const { type = 'info', duration = 5000 } = options;

    const existingToast = document.querySelector('.custom-toast');
    if (existingToast) {
        existingToast.remove();
    }

    const toast = document.createElement('div');
    
    const baseClasses = [
        'custom-toast', 'fixed', 'left-1/2', '-translate-x-1/2', 'px-4', 'py-3',
        'rounded-lg', 'shadow-lg', 'z-[9999]', 'transition-all', 'duration-300',
        'ease-in-out', 'font-sans', 'text-sm', 'flex', 'items-center', 'gap-3'
    ];

    const typeClasses = {
        info:    'bg-gray-700 text-white dark:bg-gray-200 dark:text-gray-900',
        success: 'bg-green-600 text-white dark:bg-green-500',
        error:   'bg-red-600 text-white dark:bg-red-500',
        warning: 'bg-yellow-500 text-white dark:bg-yellow-400'
    };
    
    const animationInitialState = ['opacity-0', 'bottom-5'];
    const animationVisibleState = ['opacity-100', 'bottom-8'];

    toast.className = [...baseClasses, typeClasses[type], ...animationInitialState].join(' ');
    
    const messageSpan = document.createElement('span');
    messageSpan.textContent = message;
    toast.appendChild(messageSpan);
    
    // 1. Adiciona o ícone de copiar APENAS para toasts de erro
    if (type === 'error') {
        const copyButton = document.createElement('button');
        copyButton.type = 'button';
        copyButton.className = 'p-1 rounded-md hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/50';
        copyButton.title = 'Copiar erro';
        copyButton.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
        `;
        
        // 2. Lógica para copiar para a área de transferência
        copyButton.onclick = (e) => {
            e.stopPropagation(); // Impede que o clique feche algo acidentalmente
            const textArea = document.createElement('textarea');
            textArea.value = message;
            textArea.style.position = 'fixed'; // Previne rolagem na página
            textArea.style.top = '-9999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                // 3. Feedback visual de que o texto foi copiado
                showToast('Erro copiado!', { type: 'success', duration: 2000 });
            } catch (err) {
                showToast('Falha ao copiar.', { type: 'error', duration: 2000 });
            }
            document.body.removeChild(textArea);
        };
        
        toast.appendChild(copyButton);
    }

    document.body.appendChild(toast);

    requestAnimationFrame(() => {
        toast.classList.remove(...animationInitialState);
        toast.classList.add(...animationVisibleState);
    });

    setTimeout(() => {
        if (!toast.parentNode) return;
        toast.classList.remove(...animationVisibleState);
        toast.classList.add(...animationInitialState);
        toast.addEventListener('transitionend', () => toast.remove());
    }, duration);
};
